<template>
<div class="container">
        <div class="row" v-if="content">
            <h3 class="col-sm-12">Tabelas para aprovações</h3>
            <div class="col-md-4"  style="margin-bottom:30px;" v-for="(item,i) in content" :key="i">
                <ul class="list-group">
                    <li class="list-group-item" style="display:flex; align-items:center; justify-content:space-between">
                       <h4 class="mb-0" style="font-size:1.7em;">{{item.descricao}}</h4>
                        <div style="text-align:right">
                            <p class="mb-1">Total de itens:<br> <b style="font-size:2.5em;">{{item.total}}</b></p>
                            <router-link class="btn btn-success"  :to="`${item.link}`">Acessar</router-link>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
  import {  getData } from "../global/utils";

    export default {
         data: function () {
    return {
      stripe: true,
      colorAlert: "primary",
      titleAlert: '',
      activeAlert: false,
      itemSelecionado:[],
      content: [],
      contentLista: [],
      iconArea: 50 * 1,
      errors: [],
      erro: "",
      urlApi: "painel/aprovacao",
      carregando: true,
      deleteId: "",
      deleteAtivo: null,
      deleteTitulo: "",
    };
  },
  mounted() {
    this.fnCarregaItems();
  },
  methods: {
      async fnCarregaItems() {
        let data = await getData(this.urlApi);
        this.content = data[0].content;
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>